/**
 * c-product-info-override.js (CW_008 / 2026-06-30)
 *
 * Dawn product-info カスタム要素 の updateMedia メソッド をオーバーライド。
 * [data-c-disable-variant-media-update] 属性を持つ <product-info> ではバリアント切替時の
 * ギャラリー画像変更 (setActiveMedia) をスキップする。
 *
 * 用途: section schema show_variant_image_first = false の場合に、
 *       バリアント切替で 1 枚目画像を維持したいケース。
 *
 * 対応: customElements.whenDefined で product-info 登録完了を待ち、prototype に
 *       intercept ラッパーを挿入。Dawn product-info.js は変更しない。
 *
 * 関連: sections/c-main-product.liquid {% if show_variant_image_first == false %} で属性付与
 */

(function () {
  'use strict';

  if (!('customElements' in window)) return;

  customElements.whenDefined('product-info').then(function () {
    var ProductInfo = customElements.get('product-info');
    if (!ProductInfo || !ProductInfo.prototype) return;

    var original = ProductInfo.prototype.updateMedia;
    if (typeof original !== 'function') return;

    ProductInfo.prototype.updateMedia = function (html, variantFeaturedMediaId) {
      // 該当要素に disable 属性があればスキップ (1 枚目画像を維持)
      if (this.hasAttribute('data-c-disable-variant-media-update')) {
        return;
      }
      // それ以外は Dawn 標準挙動
      return original.call(this, html, variantFeaturedMediaId);
    };
  });
})();
